export default __webpack_public_path__ + "static/media/PrgmH1.223164a8.png";